<template>
  <div>
    <v-row class="tab-row" align="center" no-gutters>
      <div class="tab-title">Ingrédients</div>
      <span v-if="ingredients.length <= 0" class="error--text overline"
        >( Veuillez ajouter au moins un ingrédient )</span
      >
    </v-row>
    <v-row
      align="stretch"
      class="inventory-tab my-1"
      no-gutters
      dense
      v-for="ingredient in [
        ...this.ingredients.filter(x => x.is_deleted === false)
      ].sort((a, b) => {
        const aV = a.ordre !== null ? a.ordre : 0;
        const bV = b.ordre !== null ? b.ordre : 0;
        return aV - bV;
      })"
      :key="ingredient.id"
    >
      <IngredientTabItem
        :recipeId="recipeId"
        :item="ingredient"
        :intermediate-product="intermediateProduct"
        :open-editors.sync="openEditors"
      ></IngredientTabItem>
    </v-row>
    <v-row class="my-1" no-gutters>
      <IngredientTabItemAdder
        :id="recipeId"
        :ingredients="ingredients"
        :intermediate-product="intermediateProduct"
        :open-editors.sync="openEditors"
      ></IngredientTabItemAdder>
    </v-row>
  </div>
</template>

<script>
import IngredientTabItem from "./IngredientTabItem.vue";
import IngredientTabItemAdder from "./IngredientTabItemAdder";
import { productMixin } from "@/mixins";
import { mapGetters } from "vuex";
export default {
  name: "IngredientTab",
  mixins: [productMixin],
  components: {
    IngredientTabItem,
    IngredientTabItemAdder
  },
  props: {
    recipeId: {
      required: true
    },
    ingredients: {
      type: Array,
      required: true
    },
    intermediateProduct: {
      required: true
    },
    valid: {
      type: Boolean,
      required: true
    },
    openEditors: {
      default: () => []
    }
  },
  computed: {
    ...mapGetters(["getAllProducts"]),
    getAllUnitValid() {
      let valid = true;
      this.ingredients.forEach(x => {
        if (this.unitIsPossible(x) === false) valid = false;
      });
      return valid;
    }
  },
  data() {
    return {
      sortedIngredients: []
    };
  },
  methods: {
    sortIngredients() {
      this.sortedIngredients = [...this.ingredients].sort((a, b) => {
        const aV = a.ordre !== null ? a.ordre : 0;
        const bV = b.ordre !== null ? b.ordre : 0;
        return aV - bV;
      });
    },
    getPossibleUnitSelectionForProduct(item) {
      const product = this.getAllProducts.find(
        x => x.id === item.pk_recette_produit
      );
      try {
        return this.getProductUnitPossibilities(product);
      } catch {
        return [];
      }
    },
    unitIsPossible(item) {
      return this.getPossibleUnitSelectionForProduct(item).includes(
        item.unite_mesure
      );
    }
  },
  watch: {
    getAllUnitValid(v) {
      this.$emit("update:valid", v);
    }
  }
};
</script>

<style scoped lang="scss">
.tab-row {
  height: 48px;
  border-bottom: solid 2px #37474f;
  .tab-title {
    font-size: 0.875rem;
    font-weight: 500;
    letter-spacing: 0.0892857143em;
    text-transform: uppercase;
    text-align: center;
    min-width: 90px;
    padding: 0 16px;
    color: #37474f;
  }
}
</style>
